import { api } from '@/api';

const Paths = {
  ALL: {
    path: '*',
    fetchInitialData: api.page.getPage
  },
  ROOT: {
    path: '/'
  }
};
export default Paths;
